<ng-container *grecoLet="eventsAndDates$ | async as eventsAndDates">
  <greco-schedule-content [events]="eventsAndDates?.events || []" [dates]="eventsAndDates?.dates || []">
  </greco-schedule-content>
</ng-container>
